export const liveChatStatusMapping: {
  online: string;
  offline: string;
  [index: string]: string;
} = {
  online: 'available',
  offline: 'not-available',
};
